import { Grid } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLModal } from "components/Tooltips/OLModal";
import { useMessage } from "hooks/intl";
import { Coupon } from "types/rewards";
import { OLDate } from "utilities/dateFormat";

const Row = ({ title, value }: { title: string; value?: string | number }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.row}>
      <Grid xs={6} item className={classes.title}>
        {title}
      </Grid>
      <Grid xs={6} item>
        {value || "-"}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      fontWeight: 700,
    },
    row: {
      paddingBottom: "15px",
      marginBottom: "15px",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      "&:first-child": {
        marginTop: "0px",
      },
      "&:last-child": {
        paddingBottom: "6px",
        marginBottom: "0px",
        borderBottom: "none",
      },
    },
  }),
);

const CouponDetailsModal = ({
  closeModal,
  open,
  couponData,
}: {
  closeModal: () => void;
  open: boolean;
  couponData?: Coupon;
}) => {
  const { message } = useMessage();

  return (
    <OLModal
      header={message({ id: "couponDetails" })}
      onClose={closeModal}
      open={open}
    >
      <>
        {couponData ? (
          <>
            {[
              {
                title: message({ id: "couponCode" }),
                value: couponData.code,
              },
              {
                title: message({ id: "couponValue" }),
                value: `${couponData.value}${
                  couponData.valueType === "percentage" ? "%" : ""
                }`,
              },
              {
                title: message({ id: "couponActiveFrom" }),
                value: OLDate(couponData.activeFrom, {
                  formatString: "dd MMM, yyyy hh:mm a",
                }),
              },
              {
                title: message({ id: "couponActiveTo" }),
                value: OLDate(couponData.activeTo, {
                  formatString: "dd MMM, yyyy hh:mm a",
                }),
              },
              {
                title: message({ id: "usageDate" }),
                value: OLDate(couponData.usedAt, {
                  formatString: "dd MMM, yyyy hh:mm a",
                }),
              },
            ].map(({ title, value }, index) => {
              return <Row title={title} value={value} key={index} />;
            })}
          </>
        ) : (
          <div>{message({ id: "noData" })}</div>
        )}
      </>
    </OLModal>
  );
};

export default CouponDetailsModal;
